import { render, staticRenderFns } from "./usersettings.vue?vue&type=template&id=35abe85c&scoped=true"
import script from "./usersettings.vue?vue&type=script&lang=js"
export * from "./usersettings.vue?vue&type=script&lang=js"
import style0 from "./usersettings.vue?vue&type=style&index=0&id=35abe85c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35abe85c",
  null
  
)

export default component.exports